﻿$.validator.methods.number = function (value, element) {
    return this.optional(element) ||
        !isNaN(Globalize.parseFloat(value));
}


$(document).ready(function () {
    InitializeGlobalization();
});

function InitializeGlobalization() {
    //Globalize.culture('da-DK');
    var lan = $("meta[name='accept-language']").attr("content");
    Globalize.culture(lan);
    //debugger;
    //$.datepicker.setDefaults($.datepicker.regional['da']);

    var theLan = "da";
    switch (lan) {
        case 'da-DK':
            theLan = "da";
            break;

        case 'en-GB':
            theLan = "en-GB";
            break;
        case 'de-DE':
            theLan = "de";
            break;
        case 'nb-NO':
            theLan = "no";
            break;
        case 'sv-SE':
            theLan = "sv";
            break;
        case 'fi-FI':
            theLan = "fi";
            break;

        case 'nl-NL':
            theLan = "nl";
            break;

        case 'fr-FR':
            theLan = "fr";
            break;

        case 'es-ES':
            theLan = "es";
            break;

        default:
            debugger;
            alert("unknown fix culture: " + lan);
            break;
    }
    $.datepicker.setDefaults($.datepicker.regional[theLan]);
    $.datepicker.regional.bookhuscurrent = theLan;
}

jQuery.extend(jQuery.validator.methods, {
    range: function (value, element, param) {
        //Use the Globalization plugin to parse the value
        var val = Globalize.parseFloat(value);
        return this.optional(element) || (val >= param[0] && val <= param[1]);
    }
});

$(function () {
    Globalize.orgParaseFloat = Globalize.parseFloat;
    Globalize.parseFloat = function (value) {
        var culture = this.findClosestCulture();
        var seperatorFound = false;
        for (var i in culture.numberFormat) {
            if (culture.numberFormat[i] == ".") {
                seperatorFound = true;
            }
        }

        if (!seperatorFound) {
            value = value.replace(".", "NaN");
        }

        return this.orgParaseFloat(value);
    };
});